import type { ActionContext, ActionTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { MapState } from "./state";
import { backend } from "@/api/backend";

type MapContext = ActionContext<MapState, State>;

export const actions: ActionTree<MapState, State> = {
  async actionSetZoom(context: MapContext, payload: number): Promise<void> {
    context.commit("setMapZoom", payload);
  },
  async actionSetMapCenter(
    context: MapContext,
    payload: { lat: number; lng: number },
  ): Promise<void> {
    context.commit("setMapCenter", payload);
  },
  async actionGetGISLayers(context: MapContext): Promise<void> {
    try {
      const response = await backend.getGeoJSONLayers(
        context.rootState.main.token,
      );
      context.commit("setGISLayers", response.data);
    } catch (error) {
      await context.dispatch("main/actionCheckApiError", error, { root: true });
    }
  },
};

const NS = "map/";

export const dispatchSetMapZoom = (store: Store<State>, payload: number) =>
  store.dispatch(`${NS}actionSetZoom`, payload);
export const dispatchSetMapCenter = (
  store: Store<State>,
  payload: { lat: number; lng: number },
) => store.dispatch(`${NS}actionSetMapCenter`, payload);
export const dispatchActionGetGISLayers = (store: Store<State>) =>
  store.dispatch(`${NS}actionGetGISLayers`);
